import { Injectable } from '@angular/core';
import { UtilityService } from './utility.service';
import { AngularFireDatabase, AngularFireObject, AngularFireList } from 'angularfire2/database';
import { Constants } from '../config/Constants';
import { Observable } from 'rxjs/Observable';
import { firebase } from '@firebase/app';
import { SplashMap } from '../models/splash-map'
import { ContentsMandatory } from '../models/contents-mandatory';

@Injectable()
export class SplashMapService {

	constructor(private db: AngularFireDatabase, private utilityService: UtilityService) { }

	getSplashData(eventId: string): Observable<SplashMap> {
		if (this.utilityService.isLogged()) {
			let data: AngularFireObject<SplashMap> = this.db.object(Constants.EVENT_URL + '/' + eventId + Constants.PREDERENCES_URL + Constants.SPLASH_URL);
			return data.valueChanges();
		}
		return null;
	}

	getFileUrl(eventId: string, cmId: string): Observable<any> {
		if (this.utilityService.isLogged()) {
			let data: AngularFireObject<any> = this.db.object(Constants.EVENT_URL + '/' + eventId + Constants.Contents_Mandatory_URL + '/' + cmId);
			return data.valueChanges();
		}
		return null;
	}

	uploadFile(eventId: string, file: File): any {
		let storageRef = firebase.storage().ref();
		let path = eventId + Constants.Contents_Mandatory_URL + Constants.STORAGE_SPLASH_URL;
		console.log(path);
		return storageRef.child(`${path}/${file.name}`).put(file);
	}

	addContentMandatory(contentsMandatory: ContentsMandatory): string {
		return this.db.list(Constants.EVENT_URL + '/' + contentsMandatory.eventId + Constants.Contents_Mandatory_URL)
			.push(contentsMandatory).key;
	}

	addSplashMap(eventId: string, splashMap: SplashMap): Promise<any> {
		splashMap = JSON.parse(JSON.stringify(splashMap))
		return this.db.object(Constants.EVENT_URL + '/' + eventId + Constants.PREDERENCES_URL + Constants.SPLASH_URL).set(splashMap);
	}

}



// WEBPACK FOOTER //
// /workspace/backend-server/src/app/core/services/splash-map.service.ts